import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import BannerSlider from '../Components/BannerSlider'
import PromotionsSlider from '../Components/PromotionsSlider'
import VenueSlider from '../Components/VenueSlider'
import LocationModel from '../Models/LocationModel'
import { getAllHomeVenues, getSportsApi, socialMediaHandles } from '../Utils/API'
import { setAllVenues, setSports } from '../Utils/Redux/sportSlice/sportSlice'
import {appLogo} from '../Utils/constant'
import { images } from '../Utils/Images'
import { socialMediaData } from '../Utils/Redux/generalOperationSlice/generalOperationSlice'

function Booking() {
    const allSports = useSelector(state => state.sport.sports)
    const socialMedialData = useSelector(state => state.generalOperation.socialMediaData)
    const homeSections = useSelector(state => state.generalOperation.homeSections)
    const show_maintenance_notice = useSelector(state => state.generalOperation.show_maintenance_notice)
    const maintenance_message = useSelector(state => state.generalOperation.maintenance_message)
    const [openPermissionModel, setOpenPermissionModel] = useState(false);
    const userLocation = useSelector(state => state.user.userLocation)
    const dispatch = useDispatch()
    const location = useLocation();
    const data = location.state

    const getAllSports = async () => {
        await getSportsApi().then(res => {
            if (res?.data?.status == 'success') {
                dispatch(setSports(res?.data?.data))
            } else {
                dispatch(setSports([]))
            }
        })
    }

    const updateSocialMediaHandles = () => {
        socialMediaHandles().then(data => {
            dispatch(socialMediaData(data))
        }).catch(err => {
            console.log(err);
        })
    }

    // Fetch all venues (non-location based) when nearby_venue is false
    const fetchAllVenues = async () => {
        try {
            const response = await getAllHomeVenues({ keyword: "", pin_code: "" })
            if (response?.data?.status === 'success' && response?.data?.data?.length > 0) {
                dispatch(setAllVenues(response.data.data))
            } else {
                dispatch(setAllVenues([]))
            }
        } catch (error) {
            console.log('Error fetching all venues:', error)
            dispatch(setAllVenues([]))
        }
    }

    useEffect(() => {
        updateSocialMediaHandles()
        getAllSports()

        // Only show location modal if nearby_venue is enabled and no location set
        if (homeSections.nearby_venue && (userLocation == null || userLocation == undefined)) {
            setOpenPermissionModel(true)
        }

        // If nearby_venue is false, fetch all venues instead
        if (!homeSections.nearby_venue) {
            fetchAllVenues()
        }
    }, [homeSections.nearby_venue])

    // Build dynamic sections array based on homeSections flags
    const sections = useMemo(() => {
        const sectionsArray = []
        if (homeSections.promotion) sectionsArray.push('promotion')
        if (homeSections.banner) sectionsArray.push('banner')
        if (homeSections.upcoming_event) sectionsArray.push('upcoming_event')
        // Always show venues section (either nearby or all)
        sectionsArray.push('venues')
        return sectionsArray
    }, [homeSections])

    return (
        <div className='bg-slate-50 col-span-2 p-4 md:p-6 md:m-10 shadow-xl rounded-md flex flex-col min-h-[calc(100vh-20vh)]'>
            {/* Maintenance Notice Banner */}
            {show_maintenance_notice && (
                <div className='mb-4 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-md'>
                    <div className='flex items-start'>
                        <div className='flex-shrink-0'>
                            <svg className='h-5 w-5 text-amber-500' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
                                <path fillRule='evenodd' d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z' clipRule='evenodd' />
                            </svg>
                        </div>
                        <div className='ml-3'>
                            <p className='text-sm text-amber-700 font-medium'>
                                {maintenance_message}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Dynamic Sections Rendering */}
            {sections.map((section) => {
                switch (section) {
                    case 'promotion':
                        return (
                            <div key="promotion" className='mb-4'>
                                <PromotionsSlider />
                            </div>
                        )
                    case 'banner':
                        return (
                            <div key="banner" className='mb-4'>
                                <BannerSlider />
                            </div>
                        )
                    case 'upcoming_event':
                        // Placeholder for future upcoming events feature
                        return null
                    case 'venues':
                        return (
                            <div key="venues" className='my-4'>
                                <VenueSlider
                                    title={homeSections.nearby_venue ? "Nearby Venues" : "All Venues"}
                                />
                            </div>
                        )
                    default:
                        return null
                }
            })}

            {/* Location Modal - Only show when nearby_venue is enabled */}
            {homeSections.nearby_venue && userLocation == null && (
                <LocationModel
                    open={openPermissionModel}
                    setOpen={setOpenPermissionModel}
                />
            )}

            {/* Footer - stays at bottom */}
            <div className='mt-auto pt-8 text-xs border-t border-dashed border-slate-300 flex flex-row justify-between'>
                <div className='flex flex-col'>
                    <div className='flex flex-row items-center mb-2'>
                        <img src={appLogo} alt='logo' className='w-10 h-10 rounded-full border border-slate-400 shadow-md' />
                        <div className='ml-2'>
                            <p>App Version: <span className='font-semibold'>1.0 V</span></p>
                        </div>
                    </div>
                    <div className='ml-1'>
                        <p className='text-gray-500'>Your Sport Community Partner</p>
                        <p className='text-gray-500 uppercase font-semibold'>Powered by<span className='font-semibold'> PLAYERS TURF</span></p>
                    </div>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <p className='text-gray-500 uppercase font-semibold'>Follow Us</p>
                    <div className="flex flex-row justify-center items-center gap-3 mt-2">
                        <a
                            href={socialMedialData?.instagram || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => !socialMedialData?.instagram && e.preventDefault()}
                        >
                            <img src={images.Instagram} alt="Instagram" className="w-[30px] h-[30px] cursor-pointer" />
                        </a>
                        <a
                            href={socialMedialData?.facebook || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => !socialMedialData?.facebook && e.preventDefault()}
                        >
                            <img src={images.Facebook} alt="Facebook" className="w-[30px] h-[30px] cursor-pointer" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Booking